import { render, staticRenderFns } from "./ngcBoolean.vue?vue&type=template&id=1926398f&scoped=true&"
import script from "./ngcBoolean.vue?vue&type=script&lang=js&"
export * from "./ngcBoolean.vue?vue&type=script&lang=js&"
import style0 from "./ngcBoolean.vue?vue&type=style&index=0&id=1926398f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1926398f",
  null
  
)

export default component.exports